module.exports = __webpack_public_path__ + "static/media/Information_Icon.34fd1c66.svg";